import React, { useEffect, useState } from "react";
import CornerLadybug from "../images/corner/corner-ladybug-art.webp";
import Fuse from "fuse.js";
import _ from "underscore";

const WhereToFind = () => {
  const [searchString, setSearchString] = useState("");

  useEffect(() => {
    // Set the document title
    document.title = "Auburn Road - Where To Find Our Wines";

    // Optionally, you can return a cleanup function if needed
    return () => {
      // This will run when the component is unmounted or before the effect runs again
      document.title = "Auburn Road Vineyards";
    };
  }, []);

  // Convert static location data into searchable array
  const locations = [
    // New Jersey
    {
      name: "5 O'Clock Wine & Spirits",
      address: "173 Bridgeton Pike, Mullica Hill, NJ 08062",
      state: "NEW JERSEY",
    },
    {
      name: "A J's Tavern",
      address: "114 N Broadway, Pennsville, NJ 08070",
      state: "NEW JERSEY",
    },
    {
      name: "Bobkat Liquors",
      address: "1361 Delsea Dr, Deptford Township, NJ 08096",
      state: "NEW JERSEY",
    },
    {
      name: "Bootleggers",
      address: "200 Tilton Road, Northfield, NJ 08225",
      state: "NEW JERSEY",
    },
    {
      name: "Bottlestop Wines & Spirits",
      address: "56 Crescent Blvd., Gloucester City, NJ 08030",
      state: "NEW JERSEY",
    },
    {
      name: "Boulevard Super Liquors",
      address: "501 Roosevelt Blvd, Marmora, NJ 08223",
      state: "NEW JERSEY",
    },
    {
      name: "Bubba's Discount Liquors",
      address: "1849 N Delsea Dr, Vineland, NJ 08360",
      state: "NEW JERSEY",
    },
    {
      name: "Buy-Rite Liquors Williamstown",
      address: "2031 N Black Horse Pike, Williamstown, NJ 08094",
      state: "NEW JERSEY",
    },
    {
      name: "Canal's of Berlin",
      address: "8 NJ Rte 73, Berlin, NJ 08009",
      state: "NEW JERSEY",
    },
    {
      name: "Canal's Discount Liquor Mart",
      address: "1299 Delsea Dr, Glassboro, NJ 08028",
      state: "NEW JERSEY",
    },
    {
      name: "Canal's Discount Liquor Mart",
      address: "10 W Rte 70, Marlton, NJ 08053",
      state: "NEW JERSEY",
    },
    {
      name: "Cherrywood Liquors",
      address: "1279 Blackwood Clementon Rd, Clementon, NJ 08021",
      state: "NEW JERSEY",
    },
    {
      name: "Clayton Liquors",
      address: "369 N Delsea Dr, Clayton, NJ 08312",
      state: "NEW JERSEY",
    },
    {
      name: "Colonial Liquor Store",
      address: "215 S Virginia Ave, Penns Grove, NJ 08069",
      state: "NEW JERSEY",
    },
    {
      name: "Cramp's Liquor Store",
      address: "4267 US-130, Edgewater Park, NJ 08010",
      state: "NEW JERSEY",
    },
    {
      name: "Deptford Liquor Mart",
      address: "1076 Delsea Drive, Westville, NJ 08093",
      state: "NEW JERSEY",
    },
    {
      name: "EZ Liquors",
      address: "35 Route 37 East, Toms River, NJ 08753",
      state: "NEW JERSEY",
    },
    {
      name: "Fairfield Inn & Suites by Marriott Mt. Laurel",
      address: "350 Century Pkwy, Mt Laurel, NJ 08054",
      state: "NEW JERSEY",
    },
    {
      name: "Fornaro's Liquor Store",
      address: "175 N Broadway, Pennsville, NJ 08070",
      state: "NEW JERSEY",
    },
    {
      name: "G's Liquor Gallery",
      address: "997 Kings Hwy, West Deptford, NJ 08086",
      state: "NEW JERSEY",
    },
    {
      name: "Haddon Culinary",
      address: "741 Haddon Ave., Collingswood, NJ 08108",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Holy Tomato",
      address: "9 S Black Horse Pike, Blackwood, NJ 08012",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Hill Creek Farms",
      address: "1631 NJ-45, Mullica Hill, NJ 08062",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Hops & Grapes",
      address: "810 Delsea Dr, Glassboro, NJ 08028",
      state: "NEW JERSEY",
    },
    {
      name: "J B Liquor",
      address: "120 Center Square Rd, Swedesboro, NJ 08085",
      state: "NEW JERSEY",
    },
    {
      name: "J Tee's Liquors Wines & Beer",
      address: "641 S Broadway, Pennsville, NJ 08070",
      state: "NEW JERSEY",
    },
    {
      name: "Joe Canal's Discount Liquor Bellmawr",
      address: "15 N Black Horse Pike, Bellmawr, NJ 08031",
      state: "NEW JERSEY",
    },
    {
      name: "Joe Canal's Discount Liquor Outlet Millville",
      address: "2213 N 2nd St, Millville, NJ 08332",
      state: "NEW JERSEY",
    },
    {
      name: "Kenny's Liquor",
      address: "414 S Delsea Dr, Clayton, NJ 08312",
      state: "NEW JERSEY",
    },
    {
      name: "King's Liquor Outlet",
      address: "542 Cross Keys Rd, Sicklerville, NJ 08081",
      state: "NEW JERSEY",
    },
    {
      name: "Liquor Mart",
      address: "554 S Delsea Dr, Vineland, NJ 08360",
      state: "NEW JERSEY",
    },
    {
      name: "Liquor Mart Logan Township",
      address: "2640 US-322, Logan Township, NJ 08085",
      state: "NEW JERSEY",
    },
    {
      name: "Liquor Mill",
      address: "200 S White Horse Pike, Magnolia, NJ 08049",
      state: "NEW JERSEY",
    },
    {
      name: "Liquor Xpress",
      address: "3600 E Landis Ave #5, Vineland, NJ 08361",
      state: "NEW JERSEY",
    },
    {
      name: "Liquor Xpress",
      address: "67 E Oak Rd, Vineland, NJ 08360",
      state: "NEW JERSEY",
    },
    {
      name: "Martin's Liquors",
      address: "3601 NJ-38, Mt Laurel, NJ 08054",
      state: "NEW JERSEY",
    },
    {
      name: "Original Canal's Discount Liquor Mart",
      address: "717 N Pearl St, Bridgeton, NJ 08302",
      state: "NEW JERSEY",
    },
    {
      name: "Passion Vines Wine Bar",
      address: "265 New Rd, Somers Point, NJ 08244",
      state: "NEW JERSEY",
    },
    {
      name: "Passion Vines Wine & Spirit Company",
      address: "3013 Ocean Heights Ave, Egg Harbor Twp, NJ 08234",
      state: "NEW JERSEY",
    },
    {
      name: "Rastelli's Market Fresh",
      address: "1276 Clements Bridge Road, Deptford, NJ 08096",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Rastelli's Market Fresh",
      address: "710 Route 73 S, Marlton, NJ 08053",
      state: "NEW JERSEY",
    },
    {
      name: "Roger Wilco Discount Liquor",
      address: "1345 Hurffville Rd, Deptford Township, NJ 08096",
      state: "NEW JERSEY",
    },
    {
      name: "ShopRite Wines & Spirits",
      address: "141 US-130, Cinnaminson, NJ 08077",
      state: "NEW JERSEY",
    },
    {
      name: "ShopRite Wines & Spirits",
      address: "382 Egg Harbor Rd, Sewell, NJ 08080",
      state: "NEW JERSEY",
    },
    {
      name: "ShopRite Wine & Spirits",
      address: "1255 W Landis Ave Suite 2, Vineland, NJ 08360",
      state: "NEW JERSEY",
    },
    {
      name: "Spirits Warehouse",
      address: "415 S Evergreen Ave, Woodbury, NJ 08096",
      state: "NEW JERSEY",
    },
    {
      name: "Super Buy Rite Liquors",
      address: "1075 Mantua Pike, West Deptford, NJ 08096",
      state: "NEW JERSEY",
    },
    {
      name: "Total Wine & More",
      address: "2100 NJ-38, Cherry Hill, NJ 08002",
      state: "NEW JERSEY",
    },
    {
      name: "TownePlace Suites by Marriott",
      address: "3 Pureland Dr, Swedesboro, NJ 08085",
      state: "NEW JERSEY",
    },
    {
      name: "Turnpike Inn",
      address: "601 S Pennsville Auburn Rd, Carneys Point, NJ 08069",
      state: "NEW JERSEY",
    },
    {
      name: "Villa Barone",
      address: "753 Haddon Ave, Collingswood, NJ 08108",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Vineland Discount Liquor",
      address: "1668 S Delsea Dr, Vineland, NJ 08360",
      state: "NEW JERSEY",
    },
    {
      name: "Wine Warehouse of Gloucester Twp",
      address: "1460 Blackwood Clementon Rd, Clementon, NJ 08021",
      state: "NEW JERSEY",
    },
    {
      name: "Wine Warehouse of Mantua",
      address: "222 Bridgeton Pike, Mantua Township, NJ 08051",
      state: "NEW JERSEY",
    },
    {
      name: "Wine Warehouse of Sicklerville",
      address: "665 Cross Keys Rd, Sicklerville, NJ 08081",
      state: "NEW JERSEY",
    },
    {
      name: "Wine Warehouse of Voorhees",
      address: "700 Haddonfield-Berlin Rd #38a, Voorhees Township, NJ 08043",
      state: "NEW JERSEY",
    },
    {
      name: "Wineworks",
      address: "319 W Rte 70, Marlton, NJ 08053",
      state: "NEW JERSEY",
    },
    {
      name: "Woodstown Tavern Hotel",
      address: "13 N Main St, Woodstown, NJ 08098",
      state: "NEW JERSEY",
    },
    {
      name: "Lyberry Coffee",
      address: "3 Old Trenton Rd, Cranbury, NJ 08512",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Nine Thai",
      address: "7 S Broadway, Pitman, NJ 08071",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Spicy Affair",
      address: "1427 Kings Hwy, Swedesboro, NJ 08085",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "In Dietro caffe",
      address: "Behind La Faccia Bella, 22 S Main St, Medford, NJ 08055",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Tavola Rustica",
      address: "243 N Union St, Lambertville, NJ 08530",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Hens & Honey",
      address: "95 Woodstown Rd, Swedesboro, NJ 08085",
      state: "NEW JERSEY",
      isOutlet: true,
    },
    {
      name: "Boaggio's Bread",
      address: "4201 Church Rd Unit 1 & 2, Mt Laurel Township, NJ 08054",
      state: "NEW JERSEY",
      isOutlet: true,
    },

    // Pennsylvania
    {
      name: "Good Karma Cafe",
      address: "928 Pine St, Philadelphia, PA 19107",
      state: "PENNSYLVANIA",
      isOutlet: true,
    },
    {
      name: "Yardley General",
      address: "14 S. Main Street, Yardley, PA 19067",
      state: "PENNSYLVANIA",
    },

    // Delaware
    {
      name: "Beaver Brook Liquors",
      address: "550 S Dupont Hwy, New Castle, DE 19720",
      state: "DELAWARE",
    },
    {
      name: "Concord Pike Liquors",
      address: "4013 Concord Pike, Wilmington, DE 19809",
      state: "DELAWARE",
    },
    {
      name: "Frank's Wine",
      address: "1206 N Union St, Wilmington, DE 19806",
      state: "DELAWARE",
    },
    {
      name: "Peco's Liquors",
      address: "522 Philadelphia Pike, Wilmington, DE 19803",
      state: "DELAWARE",
    },
    {
      name: "Wilmington Wine Company",
      address: "510 Greenhill Ave, Wilmington, DE 19805",
      state: "DELAWARE",
    },

    // Maryland
    {
      name: "State Line Liquors",
      address: "1610 Elkton Rd, Elkton, MD 21921",
      state: "MARYLAND",
    },
    {
      name: "Weaver's Discount Liquors",
      address: "1747 W Pulaski Hwy, Elkton, MD 21921",
      state: "MARYLAND",
    },
  ];

  // Set up fuzzy search
  const fuse = new Fuse(locations, {
    threshold: 0.4,
    ignoreLocation: true,
    keys: ["name", "address", "state"],
  });

  // Filter locations based on search
  const filteredLocations = _.isEmpty(searchString)
    ? locations
    : fuse.search(searchString).map((x) => x.item);

  // Group filtered locations by state
  const groupedLocations = filteredLocations.reduce((acc, location) => {
    if (!acc[location.state]) {
      acc[location.state] = [];
    }
    acc[location.state].push(location);
    return acc;
  }, {});

  return (
    <>
      <img className="corner-ladybug" src={CornerLadybug} alt="" />
      <div className="container content-page p-t-100">
        <section className="content-hero">
          <p className="content-hero__kicker">Around the region</p>
          <h1 className="huge-text-no-quote content-hero__title">
            Where To Find Our Wines
          </h1>
          <p className="content-hero__intro">
            Shops, restaurants, and outlets carrying Auburn Road across New
            Jersey, Pennsylvania, Delaware, and Maryland.
          </p>
        </section>

        <div className="content-find__map">
          <iframe
            src="https://www.google.com/maps/d/embed?mid=1ig3EuEM-XlzH39xsPaB8F_Pz8cM"
            width="100%"
            height="380"
            title="where to find our wines"
          />
        </div>

        <div className="content-find__search">
          <h3>Looking for a specific location?</h3>
          <p>Search by city, store name, or address.</p>
          <input
            className="email-input"
            onChange={(e) => setSearchString(e.target.value)}
            placeholder="Search by city, store name, or address..."
            value={searchString}
          />
          {!_.isEmpty(searchString) && (
            <p className="m-t-20">
              Found {filteredLocations.length} location
              {filteredLocations.length !== 1 ? "s" : ""}
              {filteredLocations.length === 0
                ? " - try a different search term"
                : ""}
            </p>
          )}
        </div>

        {Object.keys(groupedLocations).length > 0 ? (
          Object.entries(groupedLocations).map(([state, stateLocations]) => (
            <div className="content-find__state" key={state}>
              <h3>{state}</h3>
              <ul>
                {stateLocations.map((location, index) => (
                  <li key={`${state}-${index}`}>
                    {location.name} &ndash; {location.address}
                    {location.isOutlet && " *"}
                  </li>
                ))}
              </ul>
            </div>
          ))
        ) : (
          <div className="content-section">
            <p>
              No locations found matching your search. Try a different search
              term.
            </p>
          </div>
        )}

        <p className="content-list__author">*denotes one of our wine outlets</p>
      </div>
    </>
  );
};

export default WhereToFind;
